import type { ExternalPriceActionsType } from "../actions/ExternalPriceActions";
import {
    EXTERNAL_PRICE_SET_ENABLE,
    EXTERNAL_PRICE_SET_ERROR,
    FETCH_EXTERNAL_PRICE_FUNCTIONS,
    FINISH_EXTERNAL_PRICE_VALUE_FETCH,
    SET_EXTERNAL_PRICE_CALCULATOR_READY,
    SET_EXTERNAL_PRICE_FUNCTION_FETCH,
    SET_EXTERNAL_PRICE_TAX_LOCATION,
    START_EXTERNAL_PRICE_VALUE_FETCH,
} from "../actions/ExternalPriceActions";
import { getDefaultPriceObject } from "../../../../../common-deprecated/constants";
import type { ExternalPriceStateType } from "../../../../shared-logic/types/externalPriceTypes";

export const initialState: ExternalPriceStateType = {
    enabled: false,
    ready: false,
    error: false,
    fetchingValue: false,
    fetchingFunctions: false,
    calculatedPrice: {
        totalValue: 0,
        carPrice: null,
        tax: 0,
        totalValueWithoutTax: 0,
        extraCosts: [],
        calculatedRawData: {},
    },
    originalTotalPrice: { ...getDefaultPriceObject() },
    co2Specs: { unit: "", value: "" },
    hadError: false,
    taxLocationId: "",
};

export default (
    state: ExternalPriceStateType = initialState,
    action: ExternalPriceActionsType,
): ExternalPriceStateType => {
    switch (action.type) {
        case EXTERNAL_PRICE_SET_ENABLE:
            return { ...state, enabled: action.enable };

        case START_EXTERNAL_PRICE_VALUE_FETCH:
            return {
                ...state,
                fetchingValue: true,
                originalTotalPrice: action.originalTotalPrice,
                error: false,
                hadError: false,
            };

        case FINISH_EXTERNAL_PRICE_VALUE_FETCH:
            return {
                ...state,
                fetchingValue: false,
                ready: true,
                calculatedPrice: { ...action.calculatedPrice },
                co2Specs: action.co2Specs || { unit: "", value: "" },
            };

        case FETCH_EXTERNAL_PRICE_FUNCTIONS:
            return { ...state, fetchingFunctions: true };

        case SET_EXTERNAL_PRICE_FUNCTION_FETCH:
            return { ...state, fetchingFunctions: action.fetching };

        case SET_EXTERNAL_PRICE_CALCULATOR_READY:
            return { ...state, fetchingFunctions: false, ready: action.ready };

        case EXTERNAL_PRICE_SET_ERROR:
            const newState = {
                ...state,
                error: action.error,
                calculatedPrice: { ...initialState.calculatedPrice },
                originalTotalPrice: { ...initialState.originalTotalPrice },
                fetchingValue: false,
                fetchingFunctions: false,
            };

            if (action.error) {
                newState.hadError = true;
            }

            return newState;

        case SET_EXTERNAL_PRICE_TAX_LOCATION:
            return { ...state, taxLocationId: action.locationId };

        default:
            return state;
    }
};
